import styled from "styled-components";
import Video from "../Video/Video";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 48%;
  flex: 1;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
export const CheckboxContainerColumn = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  height: 111px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const CheckboxText = styled.div`
  position: relative;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  align-self: stretch;
  flex-direction: row;
  height: 33px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 223.68px;
  gap: 12px;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, 30%);
  filter: drop-shadow(0px 0px 2.5px rgba(0, 0, 0, 0.5));

  @media (max-width: 768px) {
    transform: translate(-50%, -50%);
  }
  @media (max-width: 450px) {
    svg {
      width: 40px;
    }
  }

  @media (max-width: 350px) {
    svg {
      width: 30px;
    }
  }
`;

export const StyledVideo = styled(Video)`
  height: 100%;
  width: unset;
  aspect-ratio: unset;
  border-radius: 12px;

  video {
    width: auto;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const UploadVideoContainer = styled.div`
  height: 310px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const UploadActions = styled.div`
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  z-index: 2;
`;

export const UploadVideoButton = styled.button`
  border-radius: 12px;
  /* border: 1px dashed #345884; */
  border: none;
  background: #0e1c31;
  height: 100%;
  width: 100%;
  cursor: pointer;
  padding: 29px 18px;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding: 24px 12px;
  }
`;

export const UploadVideoTitle = styled.p`
  color: #fff;
  font-family: Figtree;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.07px;
  margin-top: 12px;
`;

export const UploadVideoDesc = styled.p`
  color: #a1a1aa;
  text-align: center;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.06px;
  margin-top: 4px;
  max-width: 170px;
`;

export const OpenGalleryButton = styled.button`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 68px;
  width: fit-content;
  margin: 0 auto;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.07px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  z-index: 2;
  text-align: center;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    bottom: 36px;
  }
`;

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: 36px;
  height: 36px;
  padding-bottom: 2px;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const Badge = styled.div`
  transform: rotate(14.909deg);

  position: absolute;
  right: -24px;
  top: -8px;
`;
